import moment from 'moment'
import Vue from 'vue'

const usermessage = {
    namespaced: true,
    state: {
        usermessageList:[]
    },
    mutations: {
        updateUserMessages(state, newList) {
            if( Array.isArray(newList) ) {
                state.usermessageList = newList
            } else {
                let msgList = []
                msgList.push(newList)
                state.usermessageList = msgList
            }
        },
        setMessagesViewTime( state ) {
            //state.userMessagesViewTime = moment().toString()
            Vue.set(state , 'userMessagesViewTime' , moment().toString() )
        }
    },
    actions: {
        getUserMessages(context) {
            this._vm.$traveller_http.get('/traveller/restui/usermessage/getUserMessages')
            .then( response => {
                let data = response.data
                context.commit('updateUserMessages' , data )
            })
        },
        getUserMessagesForDay(context , msgdate ) {
            let startTime = moment(msgdate)
            let endTime = moment(msgdate)
            setTime( startTime , 0,0,0,0)
            setTime( endTime , 23 ,59,59,999)
            this._vm.$traveller_http.get('/traveller/restui/usermessage/getUserMessagesBetween' , 
                { params: { "startTime": startTime.toISOString() ,
                           "endTime" : endTime.toISOString() } } )
            .then( response => {
                let data = response.data
                data.forEach(updateMessage)
                context.commit('updateUserMessages' , data )
            })
        },
        sendVehicleMessage(_context, msg ) {
            return new Promise((resolve , reject) => {
                this._vm.$traveller_http.post('/traveller/restui/usermessage/sendTxtMessageToVehiclePost',
                    msg
                    )
                .then( response => {
                    resolve(response)
                    }
                ).catch((error) => {
                    reject(error);
                }) 
            } )
        }
    },
    getters: {
        newestMessageTime(state) {
            if( !Array.isArray(state.usermessageList) || state.usermessageList.length == 0) {
                return moment(0)
            }
            return moment( state.usermessageList.reduce((a,b) => {
                if( a.sendTime > b.sendTime )
                    return a;
                return b;
            })?.sendTime )
        },
        userViewTime(state) {
            return moment(state.userMessagesViewTime)
        }
    }
}

function setTime( time, hour,minute,second,millisecond ) {
    time.hour(hour)
    time.minute(minute)
    time.second(second)
    time.millisecond(millisecond)
}

function updateMessage(item ) {
    if( item.sender.type =='vehicle')
        item.direction='in'
    else
        item.direction='out'
}

export default usermessage;